<template>

  <!--
  [ 썸네일 비율 옵션 ]
  .nav-thum--16:9
  .nav-thum--3:2
  .nav-thum--4:3
  .nav-thum--1:1
  .nav-thum--3:4
  .nav-thum--2:3

  .thum--16:9
  .thum--3:2
  .thum--4:3
  .thum--1:1
  .thum--3:4
  .thum--2:3

  [ 썸네일 컬럼 옵션 ]
  .columns--1
  .columns--2
  .columns--3
  .columns--4
  .columns--5
  .columns--6
  .columns--7
  .columns--8
  .columns--9
  .columns--10
  .columns--11
  .columns--12
  
  [ 커터 옵션 ]
  .gutter--none
  .gutter--sm
  .gutter--md
  .gutter--lg
-->

  <div
    class="max-w--1200px py--40px m--auto"
    v-if="images && images.length > 0"
  >
    <div class="tabs OPTION nav-thum--16:9 thum--16:9 columns--5 gutter--sm">

      <div class="tab-content">
        <div
          class="thum__main"
          :style="`background-image:url(/api/resources/files/${images[currentIndex]});`"
        ></div>

      </div>
      <ul class="tab-nav clearfix">
        <li
          class="thum__list"
          v-for="(image, index) in images"
          :key="index"
        >
          <a
            @click="select(index)"
            class="thum__link"
            :style="`background-image:url(/api/resources/files/${image});`"
          ></a>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    images: { type: Array }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    select (index) {
      this.currentIndex = index
    }
  },
  components: {
  }
}
</script>
